import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import PropTypes from 'prop-types'
import './ViewToggle.css'

const VIEWS = [
  { id: 'list', label: 'List', ariaLabel: 'Switch to list view' },
  { id: 'week', label: 'Week', ariaLabel: 'Switch to week view' },
  { id: 'month', label: 'Month', ariaLabel: 'Switch to month view' },
]

/**
 * ViewToggle - Segmented control for switching between List, Week, and Month views.
 *
 * @param {Object} props
 * @param {string} props.currentView - Active view: 'list', 'week', or 'month'
 * @param {Function} [props.onViewChange] - Optional callback(view) called when the
 *   user selects a view. When omitted, navigates by URL instead.
 */
function ViewToggle({ currentView, onViewChange }) {
  const navigate = useNavigate()
  const { leagueId } = useParams()

  const handleViewChange = (view) => {
    if (view === currentView) return

    if (onViewChange) {
      onViewChange(view)
      return
    }

    if (!leagueId) {
      console.error('ViewToggle: leagueId is required for navigation')
      return
    }

    if (view === 'list') {
      navigate(`/leagues/${leagueId}/schedule?tab=list`)
    } else if (view === 'week') {
      navigate(`/leagues/${leagueId}/schedule`)
    } else if (view === 'month') {
      navigate(`/leagues/${leagueId}/schedule-month`)
    }
  }

  return (
    <div className="fl__view-toggle" role="group" aria-label="View switcher">
      {VIEWS.map(({ id, label, ariaLabel }) => (
        <button
          key={id}
          className={`fl__view-toggle-button ${
            currentView === id ? 'fl__view-toggle-button--active' : ''
          }`}
          onClick={() => handleViewChange(id)}
          aria-label={ariaLabel}
          aria-pressed={currentView === id}
        >
          {label}
        </button>
      ))}
    </div>
  )
}

ViewToggle.propTypes = {
  currentView: PropTypes.oneOf(['list', 'week', 'month']).isRequired,
  onViewChange: PropTypes.func,
}

export default ViewToggle
